export const preferredCurrencySymbol = (currencies, preferredCurrency) => (
  currencies.find(symbol => symbol.code === preferredCurrency).symbol
);



// WEBPACK FOOTER //
// ./src/js/utils/currency-symbol.js